import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import motelRatings from './motel-ratings'
import documents from './documents'
/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
export const lookupByPhone = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookupByPhone.url(options),
    method: 'get',
})

lookupByPhone.definition = {
    methods: ["get","head"],
    url: '/customers/lookup-by-phone',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
lookupByPhone.url = (options?: RouteQueryOptions) => {
    return lookupByPhone.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
lookupByPhone.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookupByPhone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
lookupByPhone.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: lookupByPhone.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
const lookupByPhoneForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByPhone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
lookupByPhoneForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByPhone.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByPhone
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:28
* @route '/customers/lookup-by-phone'
*/
lookupByPhoneForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByPhone.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

lookupByPhone.form = lookupByPhoneForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
export const lookupByName = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookupByName.url(options),
    method: 'get',
})

lookupByName.definition = {
    methods: ["get","head"],
    url: '/customers/lookup-by-name',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
lookupByName.url = (options?: RouteQueryOptions) => {
    return lookupByName.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
lookupByName.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookupByName.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
lookupByName.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: lookupByName.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
const lookupByNameForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByName.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
lookupByNameForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByName.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerLookupController::lookupByName
* @see app/Http/Controllers/Admin/Customers/CustomerLookupController.php:52
* @route '/customers/lookup-by-name'
*/
lookupByNameForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: lookupByName.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

lookupByName.form = lookupByNameForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/customers/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::exportMethod
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:687
* @route '/customers/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/customers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::index
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:47
* @route '/customers'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/customers/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::create
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:155
* @route '/customers/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:178
* @route '/customers'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/customers',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:178
* @route '/customers'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:178
* @route '/customers'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:178
* @route '/customers'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::store
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:178
* @route '/customers'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
export const show = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/customers/{customer}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
show.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return show.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
show.get = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
show.head = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
const showForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
showForm.get = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::show
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:230
* @route '/customers/{customer}'
*/
showForm.head = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
export const edit = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/customers/{customer}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
edit.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return edit.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
edit.get = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
edit.head = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
const editForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
editForm.get = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::edit
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:373
* @route '/customers/{customer}/edit'
*/
editForm.head = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::update
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:463
* @route '/customers/{customer}'
*/
export const update = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/customers/{customer}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::update
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:463
* @route '/customers/{customer}'
*/
update.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return update.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::update
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:463
* @route '/customers/{customer}'
*/
update.put = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::update
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:463
* @route '/customers/{customer}'
*/
const updateForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::update
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:463
* @route '/customers/{customer}'
*/
updateForm.put = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::destroy
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:523
* @route '/customers/{customer}'
*/
export const destroy = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/customers/{customer}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::destroy
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:523
* @route '/customers/{customer}'
*/
destroy.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return destroy.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::destroy
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:523
* @route '/customers/{customer}'
*/
destroy.delete = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::destroy
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:523
* @route '/customers/{customer}'
*/
const destroyForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::destroy
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:523
* @route '/customers/{customer}'
*/
destroyForm.delete = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::restoreMotel
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:574
* @route '/customers/{customer}/restore-motel'
*/
export const restoreMotel = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: restoreMotel.url(args, options),
    method: 'post',
})

restoreMotel.definition = {
    methods: ["post"],
    url: '/customers/{customer}/restore-motel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::restoreMotel
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:574
* @route '/customers/{customer}/restore-motel'
*/
restoreMotel.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return restoreMotel.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::restoreMotel
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:574
* @route '/customers/{customer}/restore-motel'
*/
restoreMotel.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: restoreMotel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::restoreMotel
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:574
* @route '/customers/{customer}/restore-motel'
*/
const restoreMotelForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restoreMotel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::restoreMotel
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:574
* @route '/customers/{customer}/restore-motel'
*/
restoreMotelForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restoreMotel.url(args, options),
    method: 'post',
})

restoreMotel.form = restoreMotelForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::sendPasswordReset
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:788
* @route '/customers/{customer}/send-password-reset'
*/
export const sendPasswordReset = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendPasswordReset.url(args, options),
    method: 'post',
})

sendPasswordReset.definition = {
    methods: ["post"],
    url: '/customers/{customer}/send-password-reset',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::sendPasswordReset
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:788
* @route '/customers/{customer}/send-password-reset'
*/
sendPasswordReset.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return sendPasswordReset.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::sendPasswordReset
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:788
* @route '/customers/{customer}/send-password-reset'
*/
sendPasswordReset.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendPasswordReset.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::sendPasswordReset
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:788
* @route '/customers/{customer}/send-password-reset'
*/
const sendPasswordResetForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendPasswordReset.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::sendPasswordReset
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:788
* @route '/customers/{customer}/send-password-reset'
*/
sendPasswordResetForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendPasswordReset.url(args, options),
    method: 'post',
})

sendPasswordReset.form = sendPasswordResetForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::block
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:651
* @route '/customers/{customer}/block'
*/
export const block = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: block.url(args, options),
    method: 'post',
})

block.definition = {
    methods: ["post"],
    url: '/customers/{customer}/block',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::block
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:651
* @route '/customers/{customer}/block'
*/
block.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return block.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::block
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:651
* @route '/customers/{customer}/block'
*/
block.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: block.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::block
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:651
* @route '/customers/{customer}/block'
*/
const blockForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: block.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::block
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:651
* @route '/customers/{customer}/block'
*/
blockForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: block.url(args, options),
    method: 'post',
})

block.form = blockForm

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::unblock
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:664
* @route '/customers/{customer}/unblock'
*/
export const unblock = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unblock.url(args, options),
    method: 'post',
})

unblock.definition = {
    methods: ["post"],
    url: '/customers/{customer}/unblock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::unblock
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:664
* @route '/customers/{customer}/unblock'
*/
unblock.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return unblock.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::unblock
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:664
* @route '/customers/{customer}/unblock'
*/
unblock.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unblock.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::unblock
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:664
* @route '/customers/{customer}/unblock'
*/
const unblockForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblock.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Customers\CustomerController::unblock
* @see app/Http/Controllers/Admin/Customers/CustomerController.php:664
* @route '/customers/{customer}/unblock'
*/
unblockForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unblock.url(args, options),
    method: 'post',
})

unblock.form = unblockForm

const customers = {
    lookupByPhone: Object.assign(lookupByPhone, lookupByPhone),
    lookupByName: Object.assign(lookupByName, lookupByName),
    export: Object.assign(exportMethod, exportMethod),
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    motelRatings: Object.assign(motelRatings, motelRatings),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    restoreMotel: Object.assign(restoreMotel, restoreMotel),
    sendPasswordReset: Object.assign(sendPasswordReset, sendPasswordReset),
    block: Object.assign(block, block),
    unblock: Object.assign(unblock, unblock),
    documents: Object.assign(documents, documents),
}

export default customers